export const Timeline = () => {
  return (
    <iframe
      title="Timeline"
      src="https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=1giff4HcPx-9TgPNeBSFB5tkMKLJC8AXP62gHNDXtwpE&font=Default&lang=en&hash_bookmark=true&initial_zoom=2&height=650"
      width="100%"
      height="650"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
      frameborder="0"
    ></iframe>
  );
};
